import React, { useState, useEffect } from "react";

type CardProps = {
    title: React.ReactNode;
    description: string;
    Icon: React.ReactNode;
};

const Card: React.FC<CardProps> = ({
                                       title,
                                       description,
                                       Icon,

                                   }) => {
    const [animate, setAnimate] = useState(true);

    // Stop animation after 3 seconds
    const ANIMATION_DURATION_MS = 3000;

    useEffect(() => {
        setTimeout(() => setAnimate(false), ANIMATION_DURATION_MS);
    }, []);

    return (
        <div className="relative group rounded-xl overflow-hidden p-[2px] h-full">
            <div
                className={`absolute -inset-[50%]
                            bg-[conic-gradient(from_0deg,#f97316,#3b82f6,#9ca3af,#f97316)]
                            pointer-events-none z-0
                            ${animate ? "animate-spin opacity-20" : "opacity-20"}
                            group-hover:animate-spin group-hover:opacity-100`}
            ></div>

            <div className="relative z-10 bg-white rounded-[10px] p-5 md:p-6 shadow hover:shadow-lg flex flex-col items-center text-center h-full">
                {Icon}

                <h3 className="text-base md:text-lg font-semibold text-blue-900 mb-2">
                    {title}
                </h3>

                <p className="text-gray-600 text-sm">
                    {description}
                </p>
            </div>
        </div>
    );
};

export default Card;


